import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { HelmetProvider } from 'react-helmet-async';

AOS.init({ duration: 1000, once: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<HelmetProvider>
		<App />
	</HelmetProvider>
);
